<template>
  <v-btn
    variant="text"
    small
    class="subjectSettingsButton"
    @click="router.push({ name: 'SubjectSettings' })"
  >
    {{ $t('profile.subjectSettings') }} &nbsp; <v-icon>mdi-cog</v-icon>
  </v-btn>
</template>

<script setup lang="ts">
  import router from '@/router';
</script>

<style scoped lang="scss">
  .subjectSettingsButton {
    color: $grey300Color !important;
  }
</style>
